export enum FilterPopoverView {
  Edit = 'Edit',
  Select = 'Select',
  EditSaved = 'EditSaved',
}

export interface IFilterPopoverState {
  view: FilterPopoverView;
}
